
import React from 'react';
import ConfirmModal from './confirmModal';
import { render as reactRender, unmount as reactUnmount } from './render';
import destroyFns from '../basics/destroyFns'

import type { ConfirmModalProps, ConfirmModalFnProps } from './confirmModal'; 

export type ConfigUpdate = ConfirmModalProps | ((prevConfig: ConfirmModalProps) => ConfirmModalProps);

/**
* @description 模态框静态函数类型
*/
const staticRender = (config: ConfirmModalProps) => {

  const onOk = () => {
    config.onOk && config.onOk();
    update({
      ...currentConfig,
      isOpen: false,
      afterClose: () => {
        if (typeof config.afterClose === 'function') {
          config.afterClose();
        }
        destroy();
      }
    });
  }

  let currentConfig: ConfirmModalProps = { ...config, onCancel: close, onOk, isOpen: true };

  const container = document.createDocumentFragment();

  /**
  * @description 渲染函数
  * @param props 属性
  */
  function render(props: ConfirmModalProps) {
    reactRender(<ConfirmModal {...props} />, container);
  }

  /**
  * @description 关闭方法
  * @param e 合成事件
  */
  function close(e?: React.SyntheticEvent): void {
    update({
      ...currentConfig,
      isOpen: false,
      afterClose: () => {
        if (typeof config.afterClose === 'function') {
          config.afterClose();
        }
        destroy();
      }
    });

    config.onCancel && config.onCancel(e);
  }

  function update(configUpdate: ConfigUpdate): void {
    if (typeof configUpdate === 'function') {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = {
        ...currentConfig,
        ...configUpdate
      };
    }
    render(currentConfig);
  }

  function destroy() {
    reactUnmount(container);
  }

  // 初始渲染
  render(currentConfig);
  destroyFns.push(close);

  return {
    destroy: close,
    update
  };
}

export function withInfo(props: ConfirmModalFnProps): ConfirmModalProps {
  return {
    type: 'info',
    ...props
  }
}

export function withConfirm(props: ConfirmModalFnProps): ConfirmModalProps {
  return {
    type: 'alert',
    ...props
  }
}

export default staticRender;
